/* SAAFA theme — interactions */
(function () {
  'use strict';
  var S = window.Saafa || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    if (S.customMoney) {
      var v = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
      return v + ' ' + (S.currencyLabel || '');
    }
    var fmt = S.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.dataset.count = count;
      el.textContent = count > 0 ? count : '';
    });
  }

  function addItems(items) {
    return fetch((S.routes && S.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || S.strings.error);
        return data;
      });
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = $('[data-qty-input]', btn.closest('[data-qty]'));
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Quick add (cards) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.textContent = S.strings.adding;
    addItems([{ id: Number(btn.dataset.quickAdd), quantity: 1 }]).then(function () {
      if (S.cartAction === 'page') { window.location.href = S.routes.cart_url; return; }
      btn.textContent = S.strings.added;
      setTimeout(function () { btn.textContent = label; }, 2000);
    }).catch(function (err) { btn.textContent = label; alert(err.message); });
  });

  /* ---------- Product form ---------- */
  function initProduct(section) {
    var form = $('[data-product-form]', section);
    var dataEl = $('[data-product-json]', section.parentNode) || $('[data-product-json]');
    if (!form || !dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]', section);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var addPrice = $('[data-add-price]', form);
    var qtyInput = $('[data-qty-input]', form);
    var msg = $('[data-product-msg]', form);
    var gift = $('[data-giftwrap]', form);
    var giftToggle = gift && $('[data-gift-toggle]', gift);
    var giftMsg = gift && $('[data-gift-message]', gift);
    var giftFlag = gift && $('[data-gift-flag]', gift);
    var mainImg = $('[data-main-image]', section);

    function currentVariant() {
      var id = Number(idInput.value);
      return data.variants.filter(function (v) { return v.id === id; })[0] || data.variants[0];
    }

    function giftPrice() {
      return gift && giftToggle.checked ? Number(gift.dataset.giftPrice || 0) : 0;
    }

    function render() {
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (priceEl) {
        priceEl.innerHTML = '<span class="money">' + formatMoney(v.price) + '</span>' +
          (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
      }
      if (addPrice) addPrice.textContent = formatMoney((v.price + giftPrice()) * qty);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? S.strings.addToCart : S.strings.soldOut;
      }
    }

    function showMedia(mediaId) {
      if (!mediaId || !mainImg) return;
      var thumb = $('[data-thumb][data-media-id="' + mediaId + '"]', section);
      if (thumb) selectThumb(thumb);
    }

    function selectThumb(thumb) {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.src;
      mainImg.srcset = thumb.dataset.srcset;
      $$('[data-thumb]', section).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }

    $$('[data-thumb]', section).forEach(function (t) {
      t.addEventListener('click', function () { selectThumb(t); });
    });

    var picker = $('[data-variant-picker]', form);
    if (picker) {
      picker.addEventListener('change', function () {
        var selected = $$('input[type="radio"]:checked', picker).map(function (i) { return i.value; });
        var match = data.variants.filter(function (v) {
          return v.options.every(function (o, idx) { return o === selected[idx]; });
        })[0];
        if (!match) return;
        idInput.value = match.id;
        render();
        showMedia(match.media_id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    if (qtyInput) qtyInput.addEventListener('change', render);
    if (giftToggle) {
      giftToggle.addEventListener('change', function () {
        gift.classList.toggle('is-on', giftToggle.checked);
        if (giftMsg) giftMsg.disabled = !giftToggle.checked;
        if (giftFlag) giftFlag.disabled = !giftToggle.checked;
        if (giftToggle.checked && giftMsg) giftMsg.focus();
        render();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var props = {};
      $$('[name^="properties["]', form).forEach(function (el) {
        if (el.disabled || !el.value) return;
        props[el.name.slice(11, -1)] = el.value;
      });
      var items = [{ id: v.id, quantity: qty, properties: props }];
      if (gift && giftToggle.checked && gift.dataset.giftVariant) {
        items.push({ id: Number(gift.dataset.giftVariant), quantity: qty });
      }
      addBtn.disabled = true;
      addLabel.textContent = S.strings.adding;
      msg && (msg.textContent = '');
      addItems(items).then(function () {
        if (S.cartAction === 'page') { window.location.href = S.routes.cart_url; return; }
        addLabel.textContent = S.strings.added;
        setTimeout(render, 2000);
        addBtn.disabled = false;
      }).catch(function (err) {
        msg && (msg.textContent = err.message);
        addBtn.disabled = false;
        render();
      });
    });

    render();
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Cart page ---------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-auto-submit]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 450);
    });
    // Persist note so it survives quantity reloads
    var note = $('#CartNote', cartForm);
    if (note) note.addEventListener('change', function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    });
  }

  /* ---------- Delivery date picker (Dubai time) ---------- */
  var dates = $('[data-delivery-dates]');
  if (dates) {
    var input = $('[data-delivery-input]');
    var lang = (dates.dataset.locale || 'ar').split('-')[0];
    var loc = lang === 'ar' ? 'ar-AE-u-nu-arab' : 'en-AE';
    var cutoff = parseInt(dates.dataset.cutoff || '13', 10);
    var closed = (dates.dataset.closed || '').split(',').filter(Boolean).map(Number);
    var tz = 'Asia/Dubai';
    var nowParts = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    var get = function (type) { return parseInt(nowParts.filter(function (p) { return p.type === type; })[0].value, 10); };
    var base = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
    var hour = get('hour') % 24;
    var options = [];
    for (var d = 0; options.length < 3 && d < 14; d++) {
      var day = new Date(base.getTime() + d * 86400000);
      if (d === 0 && hour >= cutoff) continue;
      if (closed.indexOf(day.getUTCDay()) !== -1) continue;
      options.push({ date: day, offset: d });
    }
    var weekday = new Intl.DateTimeFormat(loc, { weekday: 'long', timeZone: 'UTC' });
    var dayMonth = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long', timeZone: 'UTC' });
    var iso = function (dt) { return dt.toISOString().slice(0, 10); };

    options.forEach(function (o, i) {
      var title, sub;
      if (o.offset === 0) { title = dates.dataset.today; sub = dates.dataset.todayNote; }
      else if (o.offset === 1) { title = dates.dataset.tomorrow; sub = weekday.format(o.date); }
      else { title = weekday.format(o.date); sub = dayMonth.format(o.date); }
      var value = title + ' — ' + dayMonth.format(o.date) + ' (' + iso(o.date) + ')';
      var id = 'DeliveryDate' + i;
      var wrap = document.createElement('div');
      wrap.className = 'option';
      wrap.innerHTML = '<input type="radio" name="delivery-date" id="' + id + '"><label for="' + id + '"></label>';
      var radio = wrap.querySelector('input');
      radio.value = value;
      wrap.querySelector('label').innerHTML = '<span></span><small></small>';
      wrap.querySelector('span').textContent = title;
      wrap.querySelector('small').textContent = sub;
      if ((input.value && input.value === value) || (!input.value && i === 0)) radio.checked = true;
      radio.addEventListener('change', function () { input.value = value; });
      dates.appendChild(wrap);
    });
    var checked = $('input:checked', dates);
    if (checked) input.value = checked.value;
  }

  /* ---------- Header: search + drawer ---------- */
  var searchToggle = $('[data-search-toggle]');
  var searchPanel = $('#HeaderSearch');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open);
      if (open) $('input[type="search"]', searchPanel).focus();
    });
  }
  $$('[data-drawer-open]').forEach(function (btn) {
    var drawer = document.getElementById(btn.dataset.drawerOpen);
    if (!drawer) return;
    btn.addEventListener('click', function () {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
    $$('[data-drawer-close]', drawer).forEach(function (c) {
      c.addEventListener('click', function () {
        drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open [data-drawer-close]').forEach(function (c) { c.click(); });
  });

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.href = url.toString();
  });

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }
  // Theme editor: always show content
  if (window.Shopify && window.Shopify.designMode) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
    document.addEventListener('shopify:section:load', function (e) {
      $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
      $$('[data-product-section]', e.target).forEach(initProduct);
    });
  }
})();
